const translations = {
  // Navigation
  nav_home: 'Home',
  nav_projects: 'Projects',
  nav_studio: 'Studio',
  nav_team: 'Team',
  nav_design_process: 'Design Process',
  nav_careers: 'Careers',
  nav_contact: 'Contact',
  nav_healthcare: 'Healthcare',
  nav_hospitality: 'Hospitality',
  nav_mixed_use: 'Mixed Use',
  nav_offices: 'Offices',
  nav_residential: 'Residential',
  nav_retail: 'Retail',
  nav_interior_design: 'Interior Design',
  nav_instagram: 'Instagram',
  nav_linkedin: 'LinkedIn',
  nav_tagline: 'Architecture shaped with clarity and restraint.',

  // Hero
  hero_title: 'FS Architects',
  hero_subtitle: 'Form In Stillness',
  hero_tagline_line1: 'Form. Stillness.',
  hero_tagline_line2: 'Foundational Structures.',
  hero_cta: 'View Projects',

  // Projects page
  projects_title: 'Projects',
  projects_count: '100+ Projects',
  projects_all: 'All Projects',
  projects_all_locations: 'All Locations',
  projects_sort_date: 'Date ↑',
  projects_sort_alpha: 'Alphabetical',
  projects_search: 'Search',
  projects_viewing: 'Viewing',

  // Project detail
  detail_back: 'Back to Projects',
  detail_year: 'Year',
  detail_location: 'Location',
  detail_category: 'Category',
  detail_floor_plans: 'Floor Plans',
  detail_location_heading: "See Where It's Located",
  detail_not_found: 'Project not found.',
  detail_back_link: 'Back to Projects',

  // Footer
  footer_tagline: 'Architecture shaped with clarity and restraint.',
  footer_projects: 'Projects',
  footer_studio: 'Studio',
  footer_get_in_touch: 'Get In Touch',
  footer_newsletter: 'Newsletter',
  footer_email_placeholder: 'Your email',
  footer_copyright: '© {year} FS Architects. All rights reserved.',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Use',

  // ── Project 1: Metropolitan Healthcare Center ──
  proj_metropolitan_healthcare_center_name: 'Metropolitan Healthcare Center',
  proj_metropolitan_healthcare_center_address: 'Makati City, Metro Manila',
  proj_metropolitan_healthcare_center_category: 'Healthcare',
  proj_metropolitan_healthcare_center_description: "The Metropolitan Healthcare Center redefines the standard for medical architecture in the Philippines. Designed with a patient-first philosophy, the facility integrates natural light, biophilic elements, and intuitive wayfinding into a cohesive architectural language. The building's clean white facade and expansive glazing create a sense of openness and calm, countering the anxiety often associated with clinical environments. Every detail — from the double-height atrium to the landscaped healing gardens — was conceived to support both patient recovery and staff well-being.",
  proj_metropolitan_healthcare_center_fp0: 'Ground Floor Plan',
  proj_metropolitan_healthcare_center_fp1: 'Second Floor Plan',
  proj_metropolitan_healthcare_center_fp2: 'Third Floor Plan',

  // ── Project 2: Coastal Resort & Spa ──
  proj_coastal_resort_spa_name: 'Coastal Resort & Spa',
  proj_coastal_resort_spa_address: 'Leyte Province',
  proj_coastal_resort_spa_category: 'Hospitality',
  proj_coastal_resort_spa_description: 'Nestled along the pristine coastline of Leyte, this resort and spa is a study in the harmony between architecture and nature. The design draws from vernacular Filipino building traditions — elevated structures, woven screens, and deep overhanging eaves — reinterpreted through a contemporary minimalist lens. Each villa is oriented to capture prevailing sea breezes and frame curated views of the ocean. The spa pavilion, set among mature coconut palms, uses local stone and reclaimed timber to create an atmosphere of grounded luxury.',
  proj_coastal_resort_spa_fp0: 'Site Plan',
  proj_coastal_resort_spa_fp1: 'Villa Floor Plan',
  proj_coastal_resort_spa_fp2: 'Spa Floor Plan',

  // ── Project 3: Urban Living Complex ──
  proj_urban_living_complex_name: 'Urban Living Complex',
  proj_urban_living_complex_address: 'Cebu City',
  proj_urban_living_complex_category: 'Mixed Use',
  proj_urban_living_complex_description: 'The Urban Living Complex in Cebu City represents a new model for high-density urban development in the Philippines. The project integrates residential towers, retail podiums, and public plazas into a single cohesive urban block. The facade system — a modular grid of precast concrete panels and recessed balconies — creates a rhythmic texture that responds to the tropical climate while maintaining a strong architectural identity. At street level, a continuous arcade activates the public realm and provides shade for pedestrians.',
  proj_urban_living_complex_fp0: 'Ground Floor Plan',
  proj_urban_living_complex_fp1: 'Typical Residential Floor',
  proj_urban_living_complex_fp2: 'Podium Level Plan',

  // ── Project 4: Tech Hub Office Tower ──
  proj_tech_hub_office_tower_name: 'Tech Hub Office Tower',
  proj_tech_hub_office_tower_address: 'BGC, Taguig',
  proj_tech_hub_office_tower_category: 'Offices',
  proj_tech_hub_office_tower_description: "Rising above the Bonifacio Global City skyline, the Tech Hub Office Tower is a landmark for the Philippine technology sector. The building's double-skin glass facade acts as a thermal buffer, significantly reducing solar heat gain while maintaining panoramic views of the city. The interior is organized around a series of sky gardens at every fifth floor, providing informal collaboration spaces and biophilic relief for occupants. The ground floor is designed as a permeable public space, blurring the boundary between the corporate interior and the vibrant street life of BGC.",
  proj_tech_hub_office_tower_fp0: 'Ground Floor Plan',
  proj_tech_hub_office_tower_fp1: 'Typical Office Floor',
  proj_tech_hub_office_tower_fp2: 'Sky Garden Level',

  // ── Project 5: Hillside Residences ──
  proj_hillside_residences_name: 'Hillside Residences',
  proj_hillside_residences_address: 'Davao City',
  proj_hillside_residences_category: 'Residential',
  proj_hillside_residences_description: 'Perched on the verdant hillsides overlooking Davao City, this residential development takes its cues from the natural topography. The buildings are arranged in a cascading terraced formation, minimizing cut-and-fill earthworks and preserving the existing tree canopy. Each unit features a generous private terrace oriented toward the city and the distant silhouette of Mount Apo. The material palette — board-formed concrete, weathering steel, and local hardwood — is designed to age gracefully and develop a patina that deepens the connection to the landscape.',
  proj_hillside_residences_fp0: 'Site Plan',
  proj_hillside_residences_fp1: 'Unit Floor Plan',
  proj_hillside_residences_fp2: 'Terrace Level Plan',

  // ── Project 6: Lifestyle Shopping District ──
  proj_lifestyle_shopping_district_name: 'Lifestyle Shopping District',
  proj_lifestyle_shopping_district_address: 'CDO City',
  proj_lifestyle_shopping_district_category: 'Retail',
  proj_lifestyle_shopping_district_description: "The Lifestyle Shopping District in Cagayan de Oro reimagines the retail experience for the modern Filipino consumer. Rather than a conventional enclosed mall, the project is conceived as an open-air district of interconnected pavilions, plazas, and landscaped promenades. The architecture draws from the city's rich cultural heritage, incorporating local craft traditions into contemporary building elements. A central water feature and mature tree canopy create a microclimate that makes outdoor shopping comfortable even in the tropical heat.",
  proj_lifestyle_shopping_district_fp0: 'Site Plan',
  proj_lifestyle_shopping_district_fp1: 'Ground Floor Plan',
  proj_lifestyle_shopping_district_fp2: 'Upper Level Plan',

  // ── Project 7: Executive Suite Interiors ──
  proj_executive_suite_interiors_name: 'Executive Suite Interiors',
  proj_executive_suite_interiors_address: 'Makati City',
  proj_executive_suite_interiors_category: 'Interior Design',
  proj_executive_suite_interiors_description: "This executive suite interior project for a leading financial institution in Makati demonstrates the studio's approach to corporate interior design: rigorous, refined, and deeply considered. The design brief called for spaces that project authority and confidence while remaining warm and human in scale. The solution employs a restrained palette of dark walnut, brushed brass, and honed marble, punctuated by carefully curated works from Filipino contemporary artists. Custom millwork and bespoke furniture pieces ensure that every element is precisely tailored to the client's needs.",
  proj_executive_suite_interiors_fp0: 'Executive Floor Plan',
  proj_executive_suite_interiors_fp1: 'Boardroom Level',
  proj_executive_suite_interiors_fp2: 'Reception & Lounge',

  // ── Project 8: Waterfront Villas ──
  proj_waterfront_villas_name: 'Waterfront Villas',
  proj_waterfront_villas_address: 'Zamboanga City',
  proj_waterfront_villas_category: 'Residential',
  proj_waterfront_villas_description: 'The Waterfront Villas in Zamboanga City are a collection of private residences designed to celebrate the extraordinary natural setting of the Zamboanga Peninsula. Each villa is individually sited to maximize privacy and views, with the architecture responding to the specific conditions of each plot. The design language is rooted in the Chavacano cultural heritage of the region, with arched colonnades, terracotta roof tiles, and lush courtyard gardens reinterpreted in a contemporary idiom. The result is a collection of homes that feel both timeless and unmistakably of their place.',
  proj_waterfront_villas_fp0: 'Site Plan',
  proj_waterfront_villas_fp1: 'Ground Floor Plan',
  proj_waterfront_villas_fp2: 'Upper Floor Plan',

  // ── Project 9: City Medical Plaza ──
  proj_city_medical_plaza_name: 'City Medical Plaza',
  proj_city_medical_plaza_address: 'Cebu City',
  proj_city_medical_plaza_category: 'Healthcare',
  proj_city_medical_plaza_description: 'City Medical Plaza in Cebu City is a comprehensive outpatient medical facility designed to serve the growing healthcare needs of the Visayas region. The building is organized around a central atrium that serves as the primary wayfinding spine, drawing natural light deep into the plan and creating a legible, stress-free environment for patients and visitors. The facade features a brise-soleil system of perforated aluminum panels that filters the intense tropical sun while maintaining a sense of transparency and connection to the surrounding urban context.',
  proj_city_medical_plaza_fp0: 'Ground Floor Plan',
  proj_city_medical_plaza_fp1: 'Second Floor Plan',
  proj_city_medical_plaza_fp2: 'Atrium Section',

  // ── Project 10: Boutique Hotel Downtown ──
  proj_boutique_hotel_downtown_name: 'Boutique Hotel Downtown',
  proj_boutique_hotel_downtown_address: 'Manila',
  proj_boutique_hotel_downtown_category: 'Hospitality',
  proj_boutique_hotel_downtown_description: "Located in the historic heart of Manila, this boutique hotel occupies a sensitively restored heritage building augmented by a contemporary rear extension. The project navigates the complex relationship between preservation and innovation, retaining the original building's ornate facade and high-ceilinged interiors while introducing a new architectural language in the extension that is clearly of its time. The 48 guest rooms are individually designed, each drawing inspiration from a different chapter of Manila's rich and layered history.",
  proj_boutique_hotel_downtown_fp0: 'Ground Floor Plan',
  proj_boutique_hotel_downtown_fp1: 'Typical Guest Floor',
  proj_boutique_hotel_downtown_fp2: 'Rooftop Plan',

  // ── Project 11: Innovation Campus ──
  proj_innovation_campus_name: 'Innovation Campus',
  proj_innovation_campus_address: 'Davao City',
  proj_innovation_campus_category: 'Mixed Use',
  proj_innovation_campus_description: 'The Innovation Campus in Davao City is a purpose-built environment for research, technology, and creative industries. The masterplan organizes a series of flexible laboratory and studio buildings around a central green spine, fostering chance encounters and cross-disciplinary collaboration. The architecture is deliberately understated — a backdrop for the work and people within — with a consistent material language of exposed concrete, weathered steel, and extensive glazing. A network of covered walkways connects all buildings, providing shelter from the tropical rain while maintaining a strong connection to the landscape.',
  proj_innovation_campus_fp0: 'Masterplan',
  proj_innovation_campus_fp1: 'Lab Building Floor Plan',
  proj_innovation_campus_fp2: 'Studio Building Floor Plan',

  // ── Project 12: Corporate Headquarters ──
  proj_corporate_headquarters_name: 'Corporate Headquarters',
  proj_corporate_headquarters_address: 'Makati City',
  proj_corporate_headquarters_category: 'Offices',
  proj_corporate_headquarters_description: "This corporate headquarters for a leading Philippine conglomerate is a statement of institutional confidence and architectural ambition. The building's distinctive form — a tapering tower with a sculpted crown — establishes a new landmark on the Makati skyline. The facade is composed of a unitized curtain wall system with integrated solar shading fins, achieving a high level of energy performance without compromising the building's visual presence. The interior design, developed in close collaboration with the client, reflects the company's values of innovation, integrity, and Filipino pride.",
  proj_corporate_headquarters_fp0: 'Ground Floor Plan',
  proj_corporate_headquarters_fp1: 'Typical Office Floor',
  proj_corporate_headquarters_fp2: 'Executive Floor Plan',

  // ── Studio Page ──
  studio_about_eyebrow: 'About the Studio',
  studio_about_h2: 'Architecture that is deeply human, rigorously crafted.',
  studio_team_strip_eyebrow: 'Meet The Team',
  studio_team_heading1: 'Meet the minds',
  studio_team_heading2: 'shaping an industry.',

  // Design Process Accordion (studio page)
  studio_accordion_commitment: 'Every project we undertake is a commitment — to the land, to the people who will inhabit it, and to the discipline of architecture itself. We build for generations.',
  studio_accordion_heading1: 'Our Design',
  studio_accordion_heading2: 'Process',

  // Contact footer
  contact_footer_discuss: "Let's discuss your project.",
  contact_footer_form_note: 'Fill out the form and our team will contact you for consultation.',

  // Process page
  process_back: 'Back',
  process_page_subtext: 'Every project we undertake follows a thoughtful, collaborative process — from the first conversation to the final handover.',

  // Design Process Teaser (studio page)
  studio_teaser_eyebrow: 'How We Work',
  studio_teaser_heading: 'Want to learn our\ndesign process?',
  studio_teaser_desc: 'From the first conversation to the final handover — every project follows a clear, collaborative six-step process built around your vision.',
  studio_teaser_cta: 'Explore Our Process',
  studio_teaser_stages: '6 stages · From brief to completion',
  studio_teaser_step1: '01 Discovery',
  studio_teaser_step2: '02 Concept',
  studio_teaser_step3: '03 Development',
  studio_teaser_step4: '04 Documentation',
  studio_teaser_step5: '05 Construction',
  studio_teaser_step6: '06 Completion',

  // Studio CTA
  studio_cta_label: '02 / Collaborate',
  studio_cta_headline: 'Every great building begins with a single conversation.',
  studio_cta_desc: "Whether you have a site, a sketch, or just an idea — we'd love to hear about it. Our team takes on a select number of projects each year to ensure each one receives the full depth of our attention.",
  studio_cta_btn: 'Start a Conversation',
  studio_about_headline: 'Architecture shaped\nwith clarity and restraint.',
  studio_about_intro: 'Founded in 2008, FS Architects is a Manila-based practice dedicated to the art of considered design. We work across scales — from intimate interiors to large civic buildings — guided by a single conviction: that architecture should serve people, honour place, and endure.',
  studio_about_intro_short: 'Lorem ipsum dolor sit amet, consectetuer adipiscing',
  studio_principal_name: 'Denza',
  studio_philosophy_label: 'Our Philosophy',
  studio_philosophy_p1: 'FS Architects is an architectural firm rooted in the belief that architecture must move at the pace of life: deliberate, thoughtful, and human-centered. Guided by the philosophy of Slow Architecture, we approach every project with care and precision, proving that successful design is achieved through thoughtful craft balanced with calm cultural sophistication.',
  studio_philosophy_p2: "Every project begins with listening. We invest time in understanding our clients' lives, their aspirations, and the specific conditions of each site. This rigorous process of inquiry informs every decision — from the orientation of a building to the selection of a door handle — ensuring that the final work is not merely beautiful, but genuinely useful and deeply meaningful.",
  studio_quote: 'We do not design for the photograph. We design for the life lived within.',

  studio_founded_label: 'Year Founded',
  studio_projects_label: 'Projects Completed',
  studio_offices_label: 'Ongoing Projects',
  studio_team_label: 'Team Members',

  // Team
  studio_team_eyebrow: 'The People',
  studio_team_rest_eyebrow: 'The Team',
  studio_team_headline: 'Meet the Team',
  studio_team_subtext: 'A multidisciplinary group of architects, designers, and thinkers united by a shared commitment to craft.',
  studio_team_francisco_name: 'Fretz I. Suralta',
  studio_team_francisco_title: 'Principal Architect',
  studio_team_francisco_bio: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.',
  studio_team_francisco_bio_extended: 'Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.',
  studio_principal_credentials_btn: 'See Credentials',
  studio_team_sofia_name: 'Sofia Reyes',
  studio_team_sofia_title: 'Design Principal',
  studio_team_sofia_bio: "Sofia leads the studio's design direction with a focus on spatial experience and human scale. A graduate of UP Diliman and the Architectural Association in London, she brings a global perspective to every project.",
  studio_team_marco_name: 'Marco Villanueva',
  studio_team_marco_title: 'Project Architect',
  studio_team_marco_bio: "Marco oversees the technical development of the studio's most complex projects. His expertise in structural systems and building technology ensures that every design is as buildable as it is beautiful.",
  studio_team_elena_name: 'Elena Cruz',
  studio_team_elena_title: 'Interior Design Lead',
  studio_team_elena_bio: 'Elena heads the interior design practice, crafting environments that are refined, tactile, and deeply considered. She has a particular expertise in bespoke furniture design and material curation.',
  studio_team_rafael_name: 'Rafael Mendoza',
  studio_team_rafael_title: 'Senior Associate',
  studio_team_rafael_bio: "Rafael manages client relationships and project delivery across the studio's healthcare and civic portfolio. His calm, methodical approach ensures that complex projects are delivered on time and to the highest standard.",
  studio_team_ana_name: 'Ana Lim',
  studio_team_ana_title: 'Architect',
  studio_team_ana_bio: 'Ana joined the studio in 2019 and has quickly established herself as a key creative voice. Her work on the Hillside Residences and Coastal Resort projects has been widely recognised for its sensitivity and precision.',
  studio_team_jesse_name: 'Jesse Keane Catedral',
  studio_team_jesse_title: 'Junior Graphic Designer',
  studio_team_jesse_bio: 'Jesse is a passionate graphic designer who moves between ideas and mediums with clarity and intention. He builds digital products, shapes brand identities, and designs experiences that draw people in.',

  // Design Process
  studio_process_eyebrow: 'How We Work',
  studio_process_headline: 'Our Design Process',
  studio_process_subtext: 'A deliberate, collaborative methodology refined over fifteen years of practice.',
  studio_process_discovery_title: 'Discovery & Listening',
  studio_process_discovery_desc: 'Every project begins with an extended period of listening. We meet with clients, visit the site at different times of day, and immerse ourselves in the cultural and physical context. This phase produces no drawings — only understanding.',
  studio_process_discovery_tag: 'Phase 01',
  studio_process_concept_title: 'Concept Development',
  studio_process_concept_desc: 'From our research, a single organising idea emerges. This concept — expressed first in sketches and physical models — becomes the compass for all subsequent decisions. We present multiple directions and refine through dialogue.',
  studio_process_concept_tag: 'Phase 02',
  studio_process_design_title: 'Design Refinement',
  studio_process_design_desc: 'The chosen concept is developed in detail across all scales simultaneously — from the urban relationship of the building to the profile of a handrail. We use physical models, digital tools, and material samples to test and refine every element.',
  studio_process_design_tag: 'Phase 03',
  studio_process_documentation_title: 'Technical Documentation',
  studio_process_documentation_desc: 'Our technical team produces a comprehensive set of construction documents that translate the design intent into precise, buildable instructions. We coordinate closely with structural, mechanical, and specialist consultants throughout.',
  studio_process_documentation_tag: 'Phase 04',
  studio_process_construction_title: 'Construction Administration',
  studio_process_construction_desc: 'We maintain close involvement throughout construction, conducting regular site visits and responding promptly to contractor queries. This hands-on presence ensures that the quality of the built work matches the quality of the design.',
  studio_process_construction_tag: 'Phase 05',
  studio_process_completion_title: 'Completion & Handover',
  studio_process_completion_desc: 'At completion, we conduct a thorough review of the finished building against the original design intent. We document the project in detail and remain available to our clients long after handover — because we believe our responsibility does not end at the door.',
  studio_process_completion_tag: 'Phase 06',
  studio_process_cta_text: 'Ready to begin a conversation about your project? We would be glad to hear from you.',
  studio_process_cta_btn: 'Start a Conversation',
  studio_process_view_full: 'View Full Process',

  // ── Contact Page ──
  contact_footer_heading: 'Contact Us',
  contact_footer_desc_before: "Let's discuss your project.",
  contact_footer_form_link: 'form',
  contact_footer_desc_after: 'Fill out the form and our team will contact you for consultation.',
  contact_form_eyebrow: 'Get In Touch',
  contact_form_headline: "Let's work together.",
  contact_form_subtext: 'Tell us about your project and we will get back to you within two business days.',
  contact_field_name: 'Full Name',
  contact_field_email: 'Email Address',
  contact_field_subject: 'Subject',
  contact_field_message: 'Message',
  contact_placeholder_name: 'Your full name',
  contact_placeholder_email: 'your@email.com',
  contact_placeholder_subject: 'Select a subject',
  contact_placeholder_message: 'Tell us about your project...',
  contact_subject_new_project: 'New Project',
  contact_subject_collaboration: 'Collaboration',
  contact_subject_press: 'Press & Media',
  contact_subject_careers: 'Careers',
  contact_subject_general: 'General Inquiry',
  contact_form_submit: 'Send Message',
  contact_form_sending: 'Sending...',
  contact_form_success: 'Thank you. We will be in touch shortly.',
  contact_form_error: 'Something went wrong. Please try again.',

  // ── Careers Page ──
  careers_heading: 'Careers',
  careers_intro: 'We guide you through every step, from the first conversation to project completion, making the process clear, collaborative, and stress-free.',
  careers_why_eyebrow: 'Why Join Us',
  careers_why_heading: 'A studio built on intention.',
  careers_val_growth_title: 'Growth & Learning',
  careers_val_growth_desc: 'We invest deeply in our people. From structured mentorship programs and weekly design reviews to external workshops and conference sponsorships, every team member has the support, the tools, and the space they need to grow both professionally and creatively. Development here is not a perk; it is the practice.',
  careers_val_impact_title: 'Impact-Driven Projects',
  careers_val_impact_desc: 'Work on projects that genuinely shape communities — from civic healthcare facilities and mixed-use urban developments to carefully considered private residences. Every brief we accept carries a meaningful purpose, and every member of the team is expected to understand the weight and privilege of that responsibility.',
  careers_val_collab_title: 'Collaborative Culture',
  careers_val_collab_desc: 'Great architecture is never the product of a single voice. Our studio is built on open dialogue, shared authorship, and mutual respect at every level — from principals to apprentices. Ideas are tested openly, critiqued honestly, and refined together. The best thinking always wins, regardless of where it comes from.',
  careers_open_eyebrow: 'Open Positions',
  careers_roles_available: '{{count}} roles available.',
  careers_role_arch_title: 'Architect',
  careers_role_arch_type: 'Full-time',
  careers_role_arch_location: 'Cebu',
  careers_role_arch_dept: 'Design',
  careers_role_arch_exp: 'We are looking for a skilled and driven Architect to join our studio and take an active role in managing and delivering projects across multiple typologies.',
  careers_role_apprent_title: 'Apprentice',
  careers_role_apprent_type: 'Full-time',
  careers_role_apprent_location: 'Cebu',
  careers_role_apprent_dept: 'Design',
  careers_role_apprent_exp: 'We are looking for an eager and detail-oriented Apprentice ready to grow within a professional studio setting and contribute meaningfully from day one.',
  careers_req_revit: 'Skilled in Revit',
  careers_req_org: 'Has strong organizational and leadership abilities',
  careers_req_timelines: 'Can manage and monitor project timelines',
  careers_req_proactive: 'Is proactive in assigning tasks and meeting deadlines',
  careers_req_team: 'Thrives in a collaborative team environment',
  careers_label_experience: 'Experience',
  careers_label_requirements: 'Requirements',
  careers_apply_btn: 'Apply for this role',
  careers_hero_line1: 'Join a studio where design',
  careers_hero_line2: 'is a discipline, not a trend.',
  careers_form_heading: 'Want to join the team?',
  careers_form_desc: "Select the role you're applying for, fill in your details, and attach your portfolio or resume. We review every application carefully and will be in touch if there's a fit.",
  careers_form_position: 'Position',
  careers_form_position_placeholder: 'Select a position…',
  careers_form_open_application: 'Open Application',
  careers_form_first_name: 'First Name',
  careers_form_last_name: 'Last Name',
  careers_form_email: 'Email Address',
  careers_form_message: 'Message',
  careers_form_upload: 'Upload Resume',
  careers_form_success: "Application sent — we'll be in touch.",
  careers_form_error: 'Something went wrong. Please try again.',
  careers_form_sending: 'Sending…',
  careers_form_send: 'Send',
};

export default translations;
